import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output, ChangeDetectorRef, ViewChild } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { Store } from '@ngxs/store';
import { FeatureCoreComponent } from '@prisma/components/feature-core.component';
import { IanTranslateService } from 'core/services/ian-core-singleton.service';
import { InsightsStoreState, InsightsApplyFilterAction, InsightsResetFilterAction } from '../../insights-store/insights-store.state';
import { DinamicTagsAdvancedFilterComponent } from '@prisma/components/dinamic-tags/dinamic-tags-advanced-filter/dinamic-tags-advanced-filter.component';

@Component({
  selector: 'app-insights-advanced-search',
  templateUrl: './insights-advanced-search.component.html',
  styleUrls: ['./insights-advanced-search.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InsightsAdvancedSearchComponent extends FeatureCoreComponent implements OnInit {
  @Output() newSearch = new EventEmitter<boolean>();

  types = [];
  stores = [];
  storeTags = [];

  onlyOwnerSelected = false;
  typeSelected = [];
  categoriesSelected = [];
  storeTagsSelected = [];
  storeSelected = [];
  dateFormSelected = null;

  @ViewChild(DinamicTagsAdvancedFilterComponent) dinamicTags: DinamicTagsAdvancedFilterComponent;

  ngOnInit(): void {
    // attributes of options for combos
    this.store.select(InsightsStoreState.getTypeAttributes).subscribe(_types => (this.types = _types));
    this.store.select(InsightsStoreState.getStoreAttributes).subscribe(_stores => (this.stores = _stores));
    this.store.select(InsightsStoreState.getStoreTagsAttributes).subscribe(_storeTags => {
      this.storeTags = _storeTags;
      this.cd.detectChanges();
    });
    // selected info
    this.store.select(InsightsStoreState.onlyOwnerSelected).subscribe(val => (this.onlyOwnerSelected = val));
    this.store.select(InsightsStoreState.typesSelected).subscribe(val => (this.typeSelected = val ? val : []));
    this.store.select(InsightsStoreState.categoriesSelected).subscribe(val => (this.categoriesSelected = val || []));
    this.store.select(InsightsStoreState.storeTagsSelected).subscribe(val => (this.storeTagsSelected = val ? val : this.storeTagsSelected));
    this.store.select(InsightsStoreState.storeSelected).subscribe(val => (this.storeSelected = val ? val : []));
    this.store.select(InsightsStoreState.dateFormSelected).subscribe(val => (this.dateFormSelected = val ? val : null));
  }

  constructor(private fb: UntypedFormBuilder, private translate: IanTranslateService, private store: Store, private cd: ChangeDetectorRef) {
    super();
  }

  setCategories(evt) {
    this.categoriesSelected = evt?.level4 || [];
  }

  resetTags(tags) {
    this.storeTagsSelected = tags;
  }

  applyFilter() {
    const data = {
      onlyOwner: this.onlyOwnerSelected,
      query: null,
      types: this.typeSelected,
      categories: this.categoriesSelected,
      storeTags: this.storeTagsSelected,
      stores: this.storeSelected,
      dateFrom: this.dateFormSelected,
    };
    this.store.dispatch(new InsightsApplyFilterAction(data));
    this.newSearch.emit(true);
  }

  resetFilter() {
    this.dinamicTags.reset();
    this.store.dispatch(new InsightsResetFilterAction());
    this.newSearch.emit(true);
  }
}
